// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteSpaceGroupsList__list-fb8acb {
  flex-grow: 1;
  overflow: auto;
}

.DeleteSpaceGroupsList__list-item-fedf87 {
  align-items: center;
  cursor: pointer;
  display: flex;
  padding: 8px 24px;
}

.DeleteSpaceGroupsList__list-item-fedf87:hover,
.DeleteSpaceGroupsList__list-item-fedf87:focus {
  background-color: var(--base-15);
}

.DeleteSpaceGroupsList__list-item-fedf87:active {
  background-color: var(--base-20);
}

.DeleteSpaceGroupsList__avatar-a3c901 {
  margin-inline-end: 12px;
}

.DeleteSpaceGroupsList__info-af880a {
  flex: 1;
  padding-inline-end: 12px;
  overflow: hidden;
}

.DeleteSpaceGroupsList__name-ba0496 {
  color: var(--base-110);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
}

.DeleteSpaceGroupsList__name-wrapper-bd82db {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  overflow: hidden;
}

.DeleteSpaceGroupsList__members-count-e78c07 {
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}

.DeleteSpaceGroupsList__name-ba0496,
.DeleteSpaceGroupsList__members-count-e78c07 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.DeleteSpaceGroupsList__empty-e88346 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/DeleteSpacePopup/DeleteSpaceGroupsList/DeleteSpaceGroupsList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AACF;;AAEA;;EAEE,gCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,OAAA;EACA,wBAAA;EACA,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,4BAAA;EACA,8CAAA;AACF;;AAEA;;EAEE,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;AACF","sourcesContent":[".list {\n  flex-grow: 1;\n  overflow: auto;\n}\n\n.list-item {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  padding: 8px 24px;\n}\n\n.list-item:hover,\n.list-item:focus {\n  background-color: var(--base-15);\n}\n\n.list-item:active {\n  background-color: var(--base-20);\n}\n\n.avatar {\n  margin-inline-end: 12px;\n}\n\n.info {\n  flex: 1;\n  padding-inline-end: 12px;\n  overflow: hidden;\n}\n\n.name {\n  color: var(--base-110);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n}\n\n.name-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n  overflow: hidden;\n}\n\n.members-count {\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n\n.name,\n.members-count {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.empty {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `DeleteSpaceGroupsList__list-fb8acb`,
	"list-item": `DeleteSpaceGroupsList__list-item-fedf87`,
	"listItem": `DeleteSpaceGroupsList__list-item-fedf87`,
	"avatar": `DeleteSpaceGroupsList__avatar-a3c901`,
	"info": `DeleteSpaceGroupsList__info-af880a`,
	"name": `DeleteSpaceGroupsList__name-ba0496`,
	"name-wrapper": `DeleteSpaceGroupsList__name-wrapper-bd82db`,
	"nameWrapper": `DeleteSpaceGroupsList__name-wrapper-bd82db`,
	"members-count": `DeleteSpaceGroupsList__members-count-e78c07`,
	"membersCount": `DeleteSpaceGroupsList__members-count-e78c07`,
	"empty": `DeleteSpaceGroupsList__empty-e88346`
};
module.exports = ___CSS_LOADER_EXPORT___;
